module.exports = __webpack_public_path__ + "img/anyswap.84bed6ca.png";